class Filter {
	constructor() {
		this.initClickEvents();
	}

	initClickEvents() {
		$(document).on('click', '.open-filter-menu', this.openMobileFilterMenu.bind(this));
		$(document).on('click', '.close-filter-menu', this.closeMobileFilterMenu.bind(this));
	}

	openMobileFilterMenu() {
		$('body').addClass('filter-menu-open');
		$('.grid-wrapper').addClass('open');
	}
	closeMobileFilterMenu() {
		$('body').removeClass('filter-menu-open');
		$('.grid-wrapper').removeClass('open');
	}
}

export default new Filter;